export const isQuickBooksReserved = (billable) => !!billable?.quickBooksExportId;

export const quickBooksReservationMessage = 'This transaction belongs to a QuickBooks export and is read-only in Questri.';

export const quickBooksExportPath = (billable) => `/billing/quickbooks?tab=exports&exportId=${encodeURIComponent(billable.quickBooksExportId)}`;
